export default class UserPictureBig {
  constructor(el) {
    this.el = el;
    // this.images = this.el.getAttribute('data-big');
    this.images = document.querySelectorAll('.c-member-photo img');
    // console.log(this.images.length);
    // console.log(this.images);
  }
}



// WEBPACK FOOTER //
// ./src/main/javascripts/modules/user_picture_big.js